"use client";

/**
 * Dipertahankan sebagai jalur impor saja — implementasinya sudah disatukan ke
 * `components/ui/EmptyState`. Dulu file ini komponen terpisah dengan nama export
 * sama tapi props tak kompatibel (tidak punya prop `icon`, aksi hanya `onClick`),
 * sehingga 26 call site yang mengimpor dari sini tidak bisa menampilkan ikon
 * maupun CTA berupa tautan.
 *
 * Impor baru sebaiknya langsung dari `@/components/ui/EmptyState`.
 */
export { EmptyState } from "../EmptyState";
